export const DEVCHAIN_START_TIMEOUT = 300000 // 5m
export const DEVCHAIN_ENS = '0x5f6f7e8cc7346a11ca2def8f827b7a0b612c56a1'
export const BLOCK_GAS_LIMIT = 50e6
export const MNEMONIC =
  'explain tackle mirror kit van hammer degree position ginger unfair soup bonus'
